// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
      apiKey: "AIzaSyBJiNGgOORxKK_tnx0FuT9E_RyqrIdK93w",
      authDomain: "progabe-61a68.firebaseapp.com",
      databaseURL: "https://progabe-61a68.firebaseio.com",
      storageBucket: "progabe-61a68.appspot.com",
    }
};



// WEBPACK FOOTER //
// /Users/Gabe/Desktop/AngularApps/GabesWebsitePublic/GabesWebsite/src/environments/environment.ts